import { useContext, useMemo } from "react";
import { ConfigurationContext } from "../../../contexts/Configuration";

export function UseLabels() {
  const { appliedConfiguration = [] } = useContext(ConfigurationContext) || {};

  const labelMap = useMemo(() => {
    const configs = appliedConfiguration?.coverageFinderUIConfigs || [];
    return configs?.reduce((acc, item) => {
      acc[item.configName] = item.configValue;
      return acc;
    }, {});
  }, [appliedConfiguration]);

  const getLabel = (key, fallback = "") => labelMap[key] || fallback;

  return { getLabel };
}
